import layout from '../layout'
export default function makeScriptRoutes({
  contentType,
  components: { ScriptListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list/:categoryId`,
          component: ScriptListingContainer,
          props: {
            contentType,
          }
        },
      ]
    },
  ];
}
